<template>
  <v-card
    class="job mb-3"
    hover
    @click="goToJobDetail()"
  >
    <v-container class="pa-0">
      <v-row>
        <v-col :cols="12" :sm="12" :md="7">
          <v-card-title class="pb-2">
            <h2 style="font-weight: normal; font-size: 1rem;">
              {{ job.title }} ({{ job | formatJobWorkload }}%)
              <favorite-button
                v-show="authUser.is_employee"
                :item="job"
              />
            </h2>
          </v-card-title>
          <v-card-text class="pt-0 pr-0">
            {{ $t(`texts.months.${job.start_month}`) }} {{ job.start_year }} - {{ $t(`texts.months.${job.end_month}`) }} {{ job.end_year }}<br />
            {{ company.name }}, {{ company.place }}
          </v-card-text>
        </v-col>
        <v-col :cols="12" :sm="12" :md="5" class="py-0">
          <v-img
            @click="goToJobDetail()"
            class="pointer"
            :src="`${fileHost}/companies/${company.id}/images/standard.png?${today}`"
            height="150"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import { fileHost } from '@/config';
import FavoriteButton from '@/components/_templates/job/FavoriteButton.vue';

const { mapState: mapUserState } = createNamespacedHelpers('user');

export default {
  name: 'JobListItem',
  props: {
    job: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
  },
  components: {
    FavoriteButton,
  },
  data() {
    return {
      fileHost,
    };
  },
  computed: {
    ...mapUserState([
      'authUser',
    ]),
    today() {
      return moment().format('YYYYMMDD');
    },
    routeParams() {
      return {
        lang: this.$i18n.locale,
        id: this.job.id,
        job: this.job,
        company: this.company,
      };
    },
  },
  methods: {
    goToJobDetail() {
      this.$router.push({ name: 'job.detail', params: this.routeParams });
    },
  },
};
</script>
